import { render, staticRenderFns } from "./files-list.vue?vue&type=template&id=ae969e46&scoped=true&"
import script from "./files-list.vue?vue&type=script&lang=js&"
export * from "./files-list.vue?vue&type=script&lang=js&"
import style0 from "./files-list.vue?vue&type=style&index=0&id=ae969e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae969e46",
  null
  
)

export default component.exports